import { getAxiosWithConfig, getAxiosWithConfigAdmin } from '../Http/HttpService';
import {
  OwnBookingsResponse,
  InsertOwnBookingParams,
  UpdateOwnBookingParams,
} from '../../types/AdminTypes';
import { AxiosResponse } from 'axios';

export const fetchOwnBookings = async (
  alpdesk_token: string,
): Promise<AxiosResponse<OwnBookingsResponse>> => {
  try {
    const instance = getAxiosWithConfigAdmin(alpdesk_token);
    return instance.post('/plugin', {
      plugin: 'ownBooking',
      data: {
        module: 'ownBookingsData',
        params: {},
      },
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const insertOwnBooking = async (
  insertOwnBookingParams: InsertOwnBookingParams,
  alpdesk_token: string,
): Promise<AxiosResponse> => {
  try {
    const instance = getAxiosWithConfigAdmin(alpdesk_token);
    return instance.post('/plugin', {
      plugin: 'ownBooking',
      data: {
        module: 'insertOwnBooking',
        params: insertOwnBookingParams,
      },
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteOwnBooking = async (
  BookingParam: string,
  alpdesk_token: string,
): Promise<AxiosResponse> => {
  try {
    const instance = getAxiosWithConfigAdmin(alpdesk_token);
    return instance.post('/plugin', {
      plugin: 'ownBooking',
      data: {
        module: 'deleteOwnBooking',
        params: {
          Booking: BookingParam,
        },
      },
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const updateOwnBooking = async (
  updateOwnBookingParams: UpdateOwnBookingParams,
  alpdesk_token: string,
): Promise<AxiosResponse> => {
  try {
    const instance = getAxiosWithConfigAdmin(alpdesk_token);
    return instance.post('/plugin', {
      plugin: 'ownBooking',
      data: {
        module: 'updateOwnBooking',
        params: updateOwnBookingParams,
      },
    });
  } catch (e) {
    throw new Error(e);
  }
};
